import { ecbrRequest } from '../../request/ecbrRequest'
import { getUnpaginatedAll } from '../../../helpers/getUnpaginatedAll'

export const invoices = {
  getAll: async (params) => ecbrRequest.get('/admin/invoices', { params }),
  create: async (invoice) => ecbrRequest.post('/admin/invoices', invoice),
  getActualCompanyInvoices: async (params) =>
    ecbrRequest.get('/company/invoices', { params }),
  getAllActualCompanyInvoices: async (params) => {
    return {
      data: await getUnpaginatedAll(
        (pagination) =>
          ecbrRequest.get('/company/invoices', {
            params: { ...params, ...pagination }
          }),
        params.page,
        params.take
      )
    }
  }
}
